<template>
    <div class="lightbox">
        <div className="lightbox__content-wrapper">
            <div className="lightbox__message">{{ text }}</div>

            <button class="lightbox__close" @click="close_lightbox" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'LightBox',
    props: {
        text: {
            type: String,
            required: true,
            default: () => 'Default Text',
        },
    },
    data() {
        return {}
    },
    methods: {
        close_lightbox() {
            this.$emit('close')
        },
    },
}
</script>


// WEBPACK FOOTER //
// source/app/js/components/lightbox.vue